// extracted by mini-css-extract-plugin
export default {"container":"bTnx5enAXc8aht_lx_oI-AriaHeadingText-module-container"};